module.exports = __webpack_public_path__ + "img/ma239.dfa9462d.png";